<template>
    <div class="content_module">
         <div class="back">WEINVENT</div>
         <div class="content">
            <p class="title1">{{customer_case.name}}</p>
            <p class="title2" >{{customer_case.value}}</p>
            <p class="title3" ><span ></span></p>
            <div class="list">
                <ul class='model' >
                    <li v-for="item in customer_case.items" :ref="'contentModel'+item.ref">
                        <img :src="item.img_src" :ref="'contentImg'+item.ref" />
                        <p class="title" :ref="'contentTitle'+item.ref">{{item.name}}</p>
                        <div class="item_msg" >
                            <p class='cont' :ref="'contentItem'+item.ref">{{item.mes}}</p>
                                <p class='know_more' :ref="'contentText'+item.ref">
                                    <router-link :to="item.url">
                                        了解更多>>
                                    </router-link>
                                </p>
                        </div>
                    </li>
                </ul>
                <router-link :to="customer_case.more_url">
                    <div class='more' ref="contentMore">更多客户案例</div>
                </router-link>
            </div>
         </div>
    </div>
</template>

<script>
export default {
  name: 'customer-case',
  props:["customer_case"],
  data () {
    return {
    }
  },
  mounted () {
    let self = this
    let rightReveal=self.$root.$data.rightReveal
    let leftReveal=self.$root.$data.leftReveal
    let topReveal=self.$root.$data.topReveal
    let fooReveal=self.$root.$data.fooReveal
    let fadeReveal=self.$root.$data.fadeReveal
    for(let i in self.customer_case.items){
        let res = self.customer_case.items[i].ref
        self.$scroll().reveal(self.$refs['contentImg'+res],{...topReveal,delay:700+500*i})
        self.$scroll().reveal(self.$refs['contentTitle'+res],{...leftReveal,delay:700+500*i})
        //self.$scroll().reveal(self.$refs['contentModel'+res],{...fadeReveal,delay:200+500*i})
        self.$scroll().reveal(self.$refs['contentItem'+res],{...fooReveal,delay:700+500*i})
        self.$scroll().reveal(self.$refs['contentText'+res],{...fooReveal,delay:700+500*i})
    }
  },
}
</script>

<style scoped>
@import '../../../static/css/common.css';
.customer_img{
    width:100%;
    margin-bottom:100px;
}

.content{
    position:relative;
}
.list{
    height: 500px;
    -webkit-box-shadow: 0px 0 20px rgba(35,24,21,0.15);
    box-shadow: 0px 0 20px rgba(35,24,21,0.15);
    margin-bottom: 90px;
    position: relative;
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    /* display: flex; */
    /* -webkit-box-pack: justify; */
    -ms-flex-pack: justify;
    /* justify-content: space-between; */
    background-image: url(/static/image/bg.png);
    background-size: 100% 100%;
    margin-top:30px;
    width: 100%;
}
.list{
    display:flex;
    flex-wrap:wrap;
    align-items:center;
    padding:30px 0;
}
.model{
    display:flex;
    margin: 0 -30px;
    justify-content:space-between;
    max-height:350px;
    height:350px;
}

.model li{
    display:inline-block;
    width: 25%;
    margin: 0 10px;
    margin-top:15px;
    box-sizing: content-box;
    flex:1 1 auto;;
    overflow:hidden;
    background-color:#fff;
    list-style:none;
    position: relative;
}
.model li:nth-of-type(1) {
    box-shadow:-5px 0 20px #e0dede;
}
.model li:nth-of-type(4) {
    box-shadow:2px 0 20px #e0dede;
}
.model li img{
    width: 100%;
    height: auto;
    max-width: 100%;
    margin-top: 10px;
    padding: 0 32%;
}
.content .model li .title{
    font-size:16px;
    color:#363636;
    width:100%;
    text-align:center;
    font-weight:500;
}
.content .model li .item_msg .cont{
    font-size:14px;
    color:#656464;
    width:100%;
    line-height:30px;
    max-height:120px;
    padding:0 15px;
    text-align:left;
    margin-bottom:10px;
    overflow:hidden;
}

.content_module .content .more{
    font-size: 16px;
    color: #1745a5;
    /* border: 0px solid #1745a5; */
    -webkit-box-shadow: 0 0 20px rgba(35,24,21,0.15);
    box-shadow: 0 0 20px rgba(35,24,21,0.15);
    border-radius: 20px;
    background-color: #fff;
    padding: 1px 10px;
    /* float: left; */
    height: 40px;
    width: 150px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: -20px;
    line-height: 40px;
    cursor: pointer;
}
.content_module .content .more:hover{
    background-color:#2d8cf0;
    color:#fff;
}
.content_module .content .more:active{
    background-color:#0d50bf;
    color:#fff;
}
.content_module .content .model .item_msg{
    /*height: 150px;*/
    display: flex;
    flex-wrap: wrap;
}
.content_module .content ul li{
    padding-bottom: 10px;
}
.content_module .content ul li p{
    font-size:14px;
    padding:0 16px;
    color: black;
    text-align:center;
    line-height:30px;
}
.content_module .content .know_more{
    color:rgb(21,97,224);
    align-self:flex-end;
    text-align: left;
    position: absolute;
    bottom: 4px;
    display: block;
}
</style>
<style scoped>
    @media screen and (max-width: 667px){
        .list{
            height: 660px;
            align-items:flex-start;
            /*min-width: 445px;*/
        }
        .model{
            flex-wrap: wrap;
            margin-top: -30px;
            margin-left: 20px;
            margin-right: 20px;
            margin-bottom: 70px;
        }
        .model li{
            width: 46%;
            height:270px;
            margin: 0 2%;
            margin-top:15px;
            /*margin: 10px 10px;*/
            /*min-width: 181px;*/
        }
        .model li:nth-of-type(1) {
            box-shadow:0 -5px 20px #e0dede;
        }
        .model li:nth-of-type(2) {
            box-shadow:0 -5px 20px #e0dede;
        }
        .model li:nth-of-type(3) {
            box-shadow:none;
        }
        .model li:nth-of-type(4) {
            box-shadow:none;
        }
    }
    @media screen and (max-width: 555px){

    }
</style>



// WEBPACK FOOTER //
// src/components/common/customer_case.vue